import { Skeleton } from '../../../../Theme'

/**
 * Skeleton for ProductDetails section (Description + Reviews)
 * Displayed while product data is loading
 */
export function ProductDetailsSkeleton() {
  return (
    <>
      {/* Description Skeleton */}
      <div className="react-css bg-white xl:mb-5 mb-2 mt-5">
        <div className="bg-cards-bg">
          <Skeleton className="h-[50px] w-48 ml-10" />
        </div>
        <div className="p-6 border-2 border-solid border-cards-bg flex flex-col items-start gap-4">
          <Skeleton className="h-8 w-72" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-4/5" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>
      </div>

      {/* Reviews Skeleton */}
      <div className="react-css bg-white md:mb-10 mb-5">
        <div className="bg-cards-bg">
          <Skeleton className="h-[50px] w-32 ml-10" />
        </div>
        <div className="p-6 flex flex-col gap-6">
          {/* Rating summary skeleton */}
          <div className="flex flex-row items-center gap-8 border-b-2 pb-6">
            <Skeleton className="h-28 w-28" />
            <div className="flex flex-col gap-3">
              <Skeleton className="h-8 w-40" />
              <Skeleton className="h-5 w-28" />
            </div>
            <div className="flex flex-col gap-2 ml-8">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-4 w-32" />
            </div>
          </div>
          {/* Review items skeleton */}
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex flex-col md:flex-row gap-4 border-b-2 pb-8">
              <div className="md:w-3/12 flex flex-col gap-3">
                <Skeleton className="h-6 w-28" />
                <Skeleton className="h-4 w-24" />
              </div>
              <div className="md:w-9/12 flex flex-col gap-4">
                <Skeleton className="h-6 w-56" />
                <Skeleton className="h-5 w-36" />
                <Skeleton className="h-20 w-full" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Related Products Skeleton */}
      <div className="react-css bg-white md:mb-10 mb-5">
        <div className="bg-cards-bg">
          <Skeleton className="h-[50px] w-56 ml-10" />
        </div>
        <div className="p-6 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="flex flex-col gap-3 p-4">
              <Skeleton className="h-40 w-full" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-6 w-20" />
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
